import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { DataTableColumnHeader } from "@/components/shared/data-table/data-table-column-header";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: true,
    enableHiding: true,
  },
  {
    accessorKey: "_count.fabric_groups",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Fabric groups" />
    ),
    cell: ({ row }) => {
      const count = row.original._count.fabric_groups;
      return (
        <Badge variant="secondary">
          {count} {count === 1 ? "group" : "groups"}
        </Badge>
      );
    },
    enableSorting: true,
    enableHiding: true,
  },
];
